import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-sm' : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="尾巴漫画首页">
            <h1 className={`text-xl font-bold font-heading transition-colors duration-300 ${scrolled ? 'text-primary-500' : 'text-background-50'}`}>
              尾巴漫画
            </h1>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/' ? (scrolled ? 'text-primary-500' : 'text-background-50') : (scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50')
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname.startsWith('/category') ? (scrolled ? 'text-primary-500' : 'text-background-50') : (scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50')
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === '/about' ? (scrolled ? 'text-primary-500' : 'text-background-50') : (scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50')
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 ${
              scrolled ? 'bg-background-100 text-foreground-700 hover:bg-background-200' : 'bg-background-50/20 text-background-50 hover:bg-background-50/30 backdrop-blur-sm'
            }`} aria-label="搜索漫画">
              <i className="ri-search-line w-4 h-4 flex items-center justify-center"></i>
              <span>搜索漫画</span>
            </button>
          </div>

          <button
            className={`md:hidden flex items-center justify-center w-10 h-10 rounded-lg transition-colors ${
              scrolled ? 'text-foreground-700' : 'text-background-50'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl w-5 h-5 flex items-center justify-center`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 py-2 whitespace-nowrap">首页</Link>
            <Link to="/category/all" className="text-sm font-medium text-foreground-700 py-2 whitespace-nowrap">分类浏览</Link>
            <Link to="/about" className="text-sm font-medium text-foreground-700 py-2 whitespace-nowrap">关于我们</Link>
            <div className="border-t border-background-200/70 pt-3">
              <button className="w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-full bg-background-100 text-foreground-700 text-sm font-medium whitespace-nowrap">
                <i className="ri-search-line w-4 h-4 flex items-center justify-center"></i>
                搜索漫画
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}